module.exports = __webpack_public_path__ + "img/banner_main.069693dc.jpg";